import React from "react";
import PropTypes from 'prop-types';
import renderLoader from "../base/Loader";
import register, { checkCandidateRecruProcessExists } from '../../services/PostService';
import RegisterFormAgency from "../register/forms/RegisterFormAgency";
import {uploadCandidateFile} from "../../services/PostService";
import {getAgencyCheckboxes} from "../../services/DataGetter";
import debounce from 'lodash.debounce';
import RegisterStepInlineWarning from '../register/RegisterStep/RegisterStepInlineWarning';

export default class AgencyRegisterStep extends React.PureComponent
{
    static propTypes = {
        language: PropTypes.string.isRequired,
        positionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        nextStep: PropTypes.func.isRequired,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        email : PropTypes.string,
        phone: PropTypes.string,
        sex: PropTypes.number,
        showModal: PropTypes.func.isRequired,
        customerData: PropTypes.objectOf(Promise).isRequired,
        customerName: PropTypes.string.isRequired,
        source: PropTypes.oneOf([PropTypes.string, PropTypes.number]).isRequired,
        agency: PropTypes.string.isRequired
    };

    static defaultProps = {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        sex: null
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            firstName : this.props.firstName,
            lastName : this.props.lastName,
            email : this.props.email,
            filesToUpload: [],
            registerTries: 5,
            checkboxes : this.getCheckboxes(),
			inlineWarning: null
        };
        this.checkDuplicateCandidate();
        this.loadData();
    }

    getCheckboxes = () => {
        return getAgencyCheckboxes(this.props.agency)
            .then(response => response.json())
            .catch( exception => {
                console.log(exception);
                return this.getCheckboxes();
            });
    };

    loadData = () => {
        this.props.customerData
            .then((customerData) => {
                this.setState({loading: false, personalNumber: customerData.result['personalNumberSettings']});
            });
    };

	setUploadQueu = (files) => {
        this.setState({filesToUpload: files});
    };

    register = (data) => {
        this.setState({loading: true});
        data['customerName'] = this.props.customerName;
        data['preferedLanguage'] = this.props.language;
        data['positionId'] = this.props.positionId;
		data['agency'] = this.props.agency;
        let cvFile = sessionStorage.getItem('cv-file-mongoid');
        if(cvFile){
            data['mongoId'] = sessionStorage.getItem('cv-file-mongoid');
            data['fileName'] = sessionStorage.getItem('cv-file-name');
            data['fileSize'] = sessionStorage.getItem('cv-file-size');
            sessionStorage.removeItem('cv-file-mongoid');
            sessionStorage.removeItem('cv-file-name');
            sessionStorage.removeItem('cv-file-size');
        }
        data.sourceId = this.props.source;
        data['acceptedDocumentIds'] = JSON.parse(sessionStorage.getItem('checkboxes-'+this.props.customerName));
        data['acceptedDocumentDates'] = JSON.parse(sessionStorage.getItem('checkbox-dates-'+this.props.customerName));
        register(data, true)
            .then( response => response.json())
            .then( json => {
                sessionStorage.setItem('userId-' +this.props.customerName, json.candidateId);
                sessionStorage.setItem('apiKey-' +this.props.customerName, json.apiKey);
                Promise.all(this.state['filesToUpload']
                    .map((file) => {
                        return uploadCandidateFile(file, this.props.customerName);
                    })
                ).then((files) => {
                    sessionStorage.removeItem('userId-' + this.props.customerName);
                    sessionStorage.removeItem('apiKey-' + this.props.customerName);
                    this.props.nextStep();
                });
            })
            .catch( (error) => {
            let {registerTries} = this.state;
            if (registerTries > 0) {
                this.setState({registerTries: registerTries-1});
                this.register(data);
            }
        });
    };

	checkDuplicateCandidate = () => {
		if (this.state['firstName'] && this.state['lastName'] && this.state['email']) {
			checkCandidateRecruProcessExists(this.state['firstName'], this.state['lastName'], this.state['email'], this.props.positionId)
				.then(data => {
					this.setState({ inlineWarning: data && data.length > 0 && data[0] === true ? 'YouAlreadyAppliedForThisPositionPleaseContactTheHR' : null })
				})
		}
	}

	checkCandidateExists = debounce((name, value) => {
			if (name && value && !this.state['displayedNotification'] && this.props.positionId) {
				let stateObj = {};
				stateObj[name] = value;
				this.setState(stateObj, () => {
					this.checkDuplicateCandidate();
				});
			}
		}
		, 500);

    render() {
        if (this.state['loading']) {
            return renderLoader('d-block text-center display-3');
        }
        return (
            <div className={"section-padding-30"}>
				{this.state.inlineWarning && <RegisterStepInlineWarning warning={window.Translator.getSlug(this.state.inlineWarning, this.props.language)}/>}
                <RegisterFormAgency
                    registerFunction={this.register}
                    language={this.props.language}
                    firstName={this.props.firstName}
                    lastName={this.props.lastName}
                    email={this.props.email}
                    customerName={this.props.customerName}
                    positionId={this.props.positionId}
                    sex={this.props.sex}
                    phone={this.props.phone}
					setUploadQueu={this.setUploadQueu}
					checkCandidateExists={this.checkCandidateExists}
                    personalNumber={this.state['personalNumber']}
                    checkboxes = {this.state['checkboxes']}
                />
            </div>
        );
    }
}
